/* eslint-disable import/no-anonymous-default-export */
import base from '../base';

export default {
	styleOverrides: {
		root: {
			'&.Mui-focused': {
				color: base.palette.text.primary,
			},
		},
	},
};
